import React, { FC } from 'react'
import Image, { type ImageProps } from 'next/image'
import styled from 'styled-components'
import { colors, fonts, spaces } from '@App/static/styles/global'
import { BREAKPOINTS } from '@App/libs/utils/constants/layout'
import BreadcrumbComponentJU from '@App/libs/components/ds/Breadcrumb'
import { BreadcrumbItem } from '@App/libs/components/ds/Breadcrumb/interfaces'

const EditoriaHeader = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${spaces.jotaSpacing12};
    align-items: flex-start;
    box-sizing: border-box;
    border-bottom: 1px solid ${colors.transparent.jotaTGrayLight40};
    z-index: -2;

    padding-top: ${spaces.jotaSpacing44};
    margin-inline: ${spaces.jotaSpacing44};

    @media only screen and (max-width: ${BREAKPOINTS.MD_PX}) {
        margin-inline: ${spaces.jotaSpacing36};
    }

    @media only screen and (max-width: ${BREAKPOINTS.SM_PX}) {
        margin-inline: ${spaces.jotaSpacing16};
    }
`

const EditoriaBreadcrumb = styled(BreadcrumbComponentJU)<{
    items: BreadcrumbItem[]
}>``

const EditoriaTitle = styled.h1<{
    as?: 'h1' | 'h2'
    noBottomSpacing?: boolean
}>`
    ${({ as = 'h1' }) =>
        as === 'h1' ? fonts.jotaHeading03() : fonts.jotaHeading04()};

    color: ${colors.black.jotaBlack};
    margin: 0 0
        ${({ noBottomSpacing }) => (noBottomSpacing ? 0 : spaces.jotaSpacing8)};
`

const EditoriaSubtitle = styled.p`
    ${fonts.jotaBodyLarge};
    color: ${colors.gray.jotaGrayDark};
    margin: 0 0 ${spaces.jotaSpacing8};
`

const EditoriaImageContainer = styled.div`
    margin-block: 0 ${spaces.jotaSpacing24};
    display: grid;
    grid-auto-flow: column;
    grid-template-columns: 200px auto;
    padding: ${spaces.jotaSpacing24};
    width: 100%;
    gap: ${spaces.jotaSpacing24};
    background-color: ${colors.transparent.jotaTGrayLighter40};
    box-sizing: border-box;
    justify-items: start;
    align-items: center;
    z-index: -2;
    border-radius: ${spaces.jotaSpacing4};

    img {
        border-radius: 4px;
        max-width: 200px;
        max-height: 200px;
        overflow: hidden;
        z-index: -1;
        object-fit: cover;
    }

    @media only screen and (max-width: ${BREAKPOINTS.MD_PX}) {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }
`

const EditoriaImage: FC<ImageProps> = (props) => {
    const { src, width = 200, height = 200, alt, ...restProps } = props
    return React.createElement(
        'span',
        { ...restProps },
        React.createElement(Image, { src, width, height, alt, priority: false })
    )
}

const EditoriaImageContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${spaces.jotaSpacing12};
`

export const Editoria = {
    Header: EditoriaHeader,
    Breadcrumb: EditoriaBreadcrumb,
    Title: EditoriaTitle,
    Subtitle: EditoriaSubtitle,
    ImageContainer: EditoriaImageContainer,
    Image: EditoriaImage,
    ImageContent: EditoriaImageContent
}
